import { CommonApiRequest, Filter, Pagination } from '@iot-platform/models/common';
import { I4BGrid, I4BGridData, I4BGridOptions } from '@iot-platform/models/grid-engine';
import { ColDef, Column, ProcessCellForExportParams, RowNode } from 'ag-grid-community';
import { get } from 'lodash';

export const getColumn = (colDef: ColDef): Column =>
  ({
    ...colDef,
    isColumn: true,
    getColDef: () => colDef,
    getSort: () => 'asc',
    getColId: () => colDef?.colId,
    getParent: () => null
  }) as Column;

export const getNode = (data): RowNode => {
  const node: RowNode = new RowNode(null);
  node.data = data;
  return node;
};

export const getProcessCellForExportParams = (data, value, colDef: ColDef): ProcessCellForExportParams => {
  const params: Partial<ProcessCellForExportParams> = {
    column: getColumn({ ...colDef }),
    value,
    node: getNode({ ...data })
  };
  return params as ProcessCellForExportParams;
};

export const getGridApiRequestByGrid = (grid: I4BGrid<I4BGridOptions, I4BGridData>, filters: Filter[], pagination?: Pagination) => {
  const pageSize = get(grid, ['gridOptions', 'pageSize']);
  let limit = pageSize === -1 ? null : get(grid, ['data', 'response', 'pagination', 'limit'], get(grid, ['gridOptions', 'pageSize'], 0));
  let page = pageSize === -1 ? null : get(grid, ['data', 'response', 'pagination', 'currentPage'], 0);
  if (pagination) {
    limit = pagination.limit;
    page = pagination.currentPage;
  }
  const request: CommonApiRequest = {
    limit,
    page,
    concept: get(grid, ['masterview'], '').toLowerCase(),
    variables: get(grid, ['gridOptions', 'variableNames'], []),
    tags: get(grid, ['gridOptions', 'tagIds'], []),
    endPoint: get(grid, ['gridOptions', 'endPoint']),
    gridOptions: get(grid, ['gridOptions']),
    filters
  };
  return request;
};

// For each masterview with no isAppDefault grid, flag the most recent unscoped grid as app default.
export const resolveAppDefaultGrids = (grids: I4BGrid<I4BGridOptions, I4BGridData>[]): I4BGrid<I4BGridOptions, I4BGridData>[] =>
  grids.map((grid) => {
    const conceptGrids = grids.filter((g) => g.masterview === grid.masterview);
    if (conceptGrids.some((g) => g.isAppDefault)) return grid;

    const fallback = conceptGrids
      .filter((g) => g.businessProfileId == null && g.userId == null)
      .sort((a, b) => new Date(b.createdAt).getTime() - new Date(a.createdAt).getTime())[0];

    return fallback?.id === grid.id ? { ...grid, isAppDefault: true, isDefault: true } : grid;
  });
